module.exports = __webpack_public_path__ + "img/教学备课.b52bf405.svg";